import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import logo from "../../assets/gobuildweb-logo.png";
import { CONTACT } from "../../data/site";

const COLS = [
  { title: "Company", links: [["Home", "/"], ["What We Can Build", "/what-we-can-build"], ["Pricing", "/pricing"], ["Get My Website", "/get-started"]] },
  { title: "Explore", links: [["Services", "/services"], ["Industries", "/industries"], ["Client Login", "/client-login"], ["Pay My Bill", "/pay-my-bill"]] },
  { title: "Legal", links: [["Privacy Policy", "/privacy"], ["Terms", "/terms"], ["Contact", "/get-started"]] },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#070707]" data-testid="site-footer">
      <div className="mx-auto max-w-[1200px] px-5 py-16 md:px-8">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <img src={logo} alt="GoBuildWeb" className="h-10 w-auto" />
            <p className="mt-4 font-display text-lg text-white">Build. Launch. Grow.</p>
            <p className="mt-3 max-w-xs text-sm text-zinc-500">We build the digital foundation your business can grow on.</p>
            <div className="mt-5 space-y-2 text-sm text-zinc-400">
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-gold-400" data-testid="footer-email"><Mail size={15} className="text-gold-500" /> {CONTACT.email}</a>
              <a href={CONTACT.phoneHref} className="flex items-center gap-2 hover:text-gold-400" data-testid="footer-phone"><Phone size={15} className="text-gold-500" /> {CONTACT.phone}</a>
              <span className="flex items-center gap-2"><MapPin size={15} className="text-gold-500" /> {CONTACT.city}</span>
            </div>
          </div>
          {COLS.map((c) => (
            <div key={c.title}>
              <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-sm text-zinc-400 transition hover:text-gold-400">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-zinc-600 md:flex-row">
          <span>© {new Date().getFullYear()} GoBuildWeb. All rights reserved.</span>
          <span>{CONTACT.city} · {CONTACT.phone}</span>
        </div>
      </div>
    </footer>
  );
}
